import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useDocumentDownload } from '@/modules/files/hooks/useFileDownload';
import { diagnostics } from '@/utils/diagnostics';

// useDownloadDocument is used to download a document when the user navigates to the page
// with a downloadDocumentId query param. The document is downloaded automatically and the query param
// is removed from the url. This supports the scenario where the user is emailed a link to download.
export function useDownloadDocument() {
  const { showFeedback } = useFeedback();
  const [searchParams, setSearchParams] = useSearchParams();
  const [downloadDocument, { loading }] = useDocumentDownload();

  useEffect(() => {
    const documentId = searchParams.get('downloadDocumentId');
    if (!documentId) return;

    // Remove the query param immediately to prevent re-downloading
    searchParams.delete('downloadDocumentId');
    setSearchParams(searchParams, { replace: true });

    // Download the document. Error handling is done inside useDocumentDownload.
    downloadDocument(documentId).catch((error) => {
      diagnostics.warn('Error downloading document', { error });
      showFeedback(
        'Document download failed. This is usually because the document was deleted.'
      );
    });
  }, [searchParams, downloadDocument, setSearchParams, showFeedback]);

  return { loading };
}
